import { Theme } from "@mui/material/styles";
import { CSSProperties } from "@mui/styles/withStyles";

import { zeffyTheme } from "../../../theme/theme";
import { getTransitions } from "../css";

import { zeffyInputClasses } from "./types";

import { InputVibe } from "@/types/mui";

const getTopDownPadding = (size: "small" | "medium", theme: Theme): number =>
  size === "small" ? theme.legacySpacing(0.5) : theme.legacySpacing(1);

export const getRightLeftPadding = (theme: Theme): number => theme.legacySpacing(1);

export const getSizeStyles = (size: "small" | "medium", theme: Theme): CSSProperties => ({
  minHeight: 20,
  padding: `${getTopDownPadding(size, theme)}px  ${getRightLeftPadding(theme)}px`,
});

export const getBaseInputInputStyles = (theme: Theme): CSSProperties => ({
  ...theme.typography.body2,
  border: "none",
  borderRadius: theme.radius(1),
  height: "unset",
  margin: 0,
  outline: "none",
  padding: 0,
  boxSizing: "border-box",
  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
    "-webkit-appearance": "none",
    margin: 0,
  },
  "&[type=number]": {
    "-moz-appearance": "textfield",
  },
  "&::placeholder": {
    opacity: 1,
  },
});

export const getBaseInputContainerStyles = (labelVibeKey: InputVibe, theme: Theme): CSSProperties => {
  const textVibe = theme.palette.text[labelVibeKey];
  const borderVibe = theme.palette.border[labelVibeKey];
  const surfaceVibe = theme.palette.surface[labelVibeKey];

  return {
    ...theme.typography.body2,
    ...getTransitions("all 50ms ease-out"),
    border: `1px solid ${borderVibe.quiet}`,
    background: surfaceVibe.white,
    borderRadius: theme.radius(1),
    color: textVibe.moderate,
    fill: textVibe.moderate,
    "& input::placeholder, & textarea::placeholder": {
      color: theme.constants.isFormV2 ? zeffyTheme.palette.text.form.supershy : theme.palette.text.form.supershy,
    },
    "&:hover": {
      borderColor: theme.palette.border.brand.intense,
    },
    [`&.${zeffyInputClasses.disabled}`]: {
      background: surfaceVibe.moderate,
      borderColor: borderVibe.moderate,
      color: textVibe.moderate,
      fill: textVibe.moderate,
      opacity: 0.4,
      "&:hover": {
        borderColor: borderVibe.moderate,
      },
    },
  };
};

export const getBaseInputFocusedStyles = (theme: Theme): CSSProperties => ({
  borderColor: theme.palette.border.brand.intense,
  boxShadow: `0 0 0 3px ${theme.palette.border.brand.moderate}`,
  outline: "none",
});

export const getBaseInputErrorStyles = (theme: Theme): CSSProperties => ({
  borderColor: theme.palette.border.danger.intense,
});
